import { render, staticRenderFns } from "./picUpload.vue?vue&type=template&id=d0d6dbf6&scoped=true&"
import script from "./picUpload.vue?vue&type=script&lang=js&"
export * from "./picUpload.vue?vue&type=script&lang=js&"
import style0 from "./picUpload.vue?vue&type=style&index=0&id=d0d6dbf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d6dbf6",
  null
  
)

export default component.exports